import React from 'react';
import classNames from 'classnames';
import { sanitize } from '../../services/sanitizeService';
import calloutBoxStyles from './CalloutBox.module.scss';

const BASE_CLASS = calloutBoxStyles['callout-box__copy'];

const CalloutBoxCopy = ({ fullCopy, customClass = '' }) => (
  <>
    <div
      className={classNames(BASE_CLASS, customClass)}
      dangerouslySetInnerHTML={{
        __html: sanitize(fullCopy),
      }}
    />
  </>
);

export default CalloutBoxCopy;
